'use client';
import CardActions from './card-actions';
import NextImage from '@/components/ui/next-image';
import { handlePriceByComma } from '@/helpers/common';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { useRouter } from '@/i18n/navigation';

function ProductCard({
  product,
  fromDetails,
  status,
  mage,
  fromRateModal = false,
}) {
  const { push } = useRouter();

  const image =
    !fromDetails && !fromRateModal
      ? product.image
      : `/media/catalog/product/${product?.extension_attributes?.product_image}`;

  const url = `/product/${Array.isArray(product?.extension_attributes?.rewrite_url) ? product?.extension_attributes?.rewrite_url?.[0] : product?.extension_attributes?.rewrite_url}`;
  return (
    <div
      className={`flex flex-col gap-3 max-sm:mb-2 sm:my-2 md:mb-6 md:gap-6 lg:px-8 ${fromDetails || fromRateModal ? 'relative sm:pb-6' : ''}`}
    >
      <div className='flex gap-3 sm:items-center'>
        <div onClick={() => push(url)}>
          <NextImage
            src={`${process.env.NEXT_PUBLIC_IMG_BASEURL}${image}`}
            alt={product.name}
            width={100}
            height={100}
            className='border-border rounded-lg border max-sm:size-20'
            objectFit='contain'
          />
        </div>
        <div className='flex w-full flex-col'>
          <div
            onClick={() => push(url)}
            className='line-clamp-2 max-sm:text-xs sm:text-sm md:text-base lg:max-w-3/4'
          >
            {product?.name ||
              'Lorem, ipsum dolor sit amet consectetur adipisicing elit. At, voluptatem quidem. Obcaecati perspiciatis sequi alias atque vero quae iure ea.'}
          </div>
          <div className='mt-6 flex flex-col items-start justify-between gap-2 max-sm:mt-1 md:flex-row lg:mt-3'>
            <p className='flex items-center gap-2 font-semibold max-sm:text-xs sm:text-sm md:text-base'>
              <span className='text-primary max-sm:font-bold'>
                {product?.qty_ordered || 1} ×{' '}
              </span>
              <span className='flex items-center gap-1'>
                <span className='font-bold'>
                  {handlePriceByComma(
                    product?.price_incl_tax || product?.price
                  )}
                </span>{' '}
                <CurrencyIcon className='size-3 md:size-3.5 lg:size-4' />
              </span>
            </p>
          </div>
        </div>
      </div>
      {fromDetails && (status == 'delivered' || status == 'complete') && (
        <CardActions product={product} mage={mage} />
      )}
    </div>
  );
}

export default ProductCard;
